import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { ConversationJSONAModel } from "../interfaces/jsona-models/ConversationJSONAModel";

export class ConversationSelector extends BaseApiSelector<ConversationJSONAModel> {
  constructor() {
    super(ResourceType.Conversation);
  }
}
